import { Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';

@Injectable()
export class EMailAddressPresetProvider {
  constructor() {}
  getConfiguration(): FormlyFieldConfig {
    return {
            key: 'email',
            type: 'input',
            props: {
                label: 'EMail Address',
                pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                required: true,
            },
            validation: {
                messages: {
                    pattern: (error: any, field: FormlyFieldConfig) => `"${field.formControl?.value}" is not a valid EMail Address`,
                },
            },
    };
  }
}

export function registerEMailAddressPreset(): ConfigOption {
  return {
    presets: [
      {
        name: 'email',
        config: new EMailAddressPresetProvider(),
      },
    ],
  };
}